webpackJsonp([108788514746826],{

/***/ 643:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Letop = __webpack_require__(7);
	
	var _Letop2 = _interopRequireDefault(_Letop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "mannelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "vrouwelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "onzijdig"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "qui"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "quae"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "quod"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "cuius"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "cuius"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "cuius"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "cui"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "cui"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "cui"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "quem"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "quam"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "quod"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "quo"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "qua"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "quo"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "qui"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "quae"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "quae"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "quorum"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "quarum"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "quorum"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "quibus"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "quibus"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "quibus"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "quos"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "quas"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "quae"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "abl. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "quibus"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "quibus"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "quibus"
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TableSelector = __webpack_require__(28);
	
	var _TableSelector2 = _interopRequireDefault(_TableSelector);
	
	var _betrVnw = __webpack_require__(643);
	
	var _betrVnw2 = _interopRequireDefault(_betrVnw);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var data = [{
	  les: "24",
	  table: _betrVnw2.default
	}];
	
	exports.default = function () {
	  return _react2.default.createElement(_TableSelector2.default, {
	    defaultChapter: "24",
	    data: data,
	    title: "Betrekkelijk voornaamwoord"
	  });
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-spqr-rijtjes-betrekkelijk-voornaamwoord-js-5446a399e0541f10a426.js